import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { CreditFacilitiesProvider } from '~/contexts/CreditFacilitiesProvider/CreditFacilitiesProvider';
import { CoreGlobalNav } from '~/core/CoreGlobalNav';
import { AppHeader } from '~/packages/common-frontend/layout/Header';
import { CreditFacilityProvider } from '~/packages/credit-facility/hooks/CreditFacilityProvider';

type Props = { children: React.ReactNode };
export const CapitalProviderTemplate = ({ children }: Props) => {
  return (
    <>
      <AppHeader />
      <Flex grow={1} pt="84px">
        <CoreGlobalNav />
        <Box width="100%" overflowX="auto">
          {/* !TODO @eldarshamukhamedov Will I ever get time to clean up this provider mess? Only time will tell =( */}
          <CreditFacilitiesProvider>
            <CreditFacilityProvider>{children}</CreditFacilityProvider>
          </CreditFacilitiesProvider>
        </Box>
      </Flex>
    </>
  );
};
